import { Stack, Typography } from "@mui/material"
import React from "react"

export default function LabelValue({ label, value }) {
	return (
		<Stack direction="column" alignItems="left" spacing={0}>
			<Typography variant="body1" color="textPrimary" sx={{ uppercase: true }}>
				{label}
			</Typography>
			<Typography variant="body2" color="textSecondary">
				{value}
			</Typography>
		</Stack>
	)
}
